const MASTER_PERMISSIONS = {
  industry: "masters.industry.view",
  "revenue-goal": "masters.revenue_goal.view",
  capability: "masters.capability.view",
  "business-problem": "masters.business_problem.view",
  "lead-status": "masters.lead_status.view",
  "lead-stage": "masters.lead_stage.view",
  "sales-stage": "masters.sales_stage.view",
};

export const getRoutePermission = (pathname) => {
  const masterMatch = pathname.match(/^\/masters\/([^/]+)/);
  if (masterMatch) return MASTER_PERMISSIONS[masterMatch[1]] || null;

  if (pathname === "/portfolio/add") return "portfolio.create";
  if (pathname.startsWith("/portfolio/edit/")) return "portfolio.update";
  if (pathname.startsWith("/portfolio")) return "portfolio.view";

  if (pathname === "/case-studies/add") return "case_studies.create";
  if (pathname.startsWith("/case-studies/edit/")) return "case_studies.update";
  if (pathname.startsWith("/case-studies")) return "case_studies.view";

  if (pathname === "/blogs/add") return "blogs.create";
  if (pathname.startsWith("/blogs/edit/")) return "blogs.update";
  if (pathname.startsWith("/blogs")) return "blogs.view";

  if (pathname === "/pages/add") return "pages.create";
  if (pathname.startsWith("/pages/edit/")) return "pages.update";
  if (pathname === "/pages/reorder") return "pages.reorder";
  if (pathname.startsWith("/pages")) return "pages.view";

  if (pathname.startsWith("/contacts")) return "contacts.view";
  if (pathname.startsWith("/roles")) return "roles.view";
  if (pathname.startsWith("/admin-users")) return "users.view";
  return null;
};
